import {
  CloudDownload as DownloadIcon,
  Apps as ProductIcon,
  InsertDriveFile as ResourceIcon,
  Assessment as SessionIcon,
  People as UserIcon,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";

const AdminDashboardPage = () => {
  const navigate = useNavigate();
  const [recentActivity, setRecentActivity] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const adminFeatures = [
    {
      title: "Product Management",
      description: "Add, edit, and delete products and their versions",
      icon: <ProductIcon fontSize="large" color="primary" />,
      path: "/admin/products",
    },
    {
      title: "User Management",
      description: "Manage user accounts and permissions",
      icon: <UserIcon fontSize="large" color="primary" />,
      path: "/admin/users",
    },
    {
      title: "Download Statistics",
      description: "View download metrics and usage statistics",
      icon: <DownloadIcon fontSize="large" color="primary" />,
      path: "/admin/statistics",
    },
    {
      title: "Session Viewer",
      description: "Analyze user sessions and event logs",
      icon: <SessionIcon fontSize="large" color="primary" />,
      path: "/admin/sessions",
    },
    {
      title: "Resource Management",
      description: "Manage resource categories and files for users",
      icon: <ResourceIcon fontSize="large" color="primary" />,
      path: "/admin/resources",
    },
  ];

  const handleNavigate = (path) => {
    navigate(path);
  };

  useEffect(() => {
    fetchRecentActivity();
  }, []);

  const fetchRecentActivity = async () => {
    try {
      setLoading(true);
      const response = await api.get("/admin/recent-activity");
      setRecentActivity(response.data);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      console.error("Error fetching recent activity:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* <Typography variant="h4" component="h1" gutterBottom>
        Secfore Portal
      </Typography> */}

      <Grid container spacing={3} sx={{ justifyContent: "center" }}>
        {adminFeatures.map((feature, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            lg={4}
            xl={3}
            key={index}
            sx={{ display: "flex" }}
          >
            <Paper
              elevation={2}
              sx={{
                p: 3,
                display: "flex",
                flexDirection: "column",
                height: 220,
                minHeight: 220,
                width: "100%",
                maxWidth: 350,
                margin: "0 auto",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": {
                  transform: "scale(1.03)",
                  boxShadow: 6,
                  borderColor: "primary.main",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                {feature.icon}
                <Typography variant="h6" component="h2" sx={{ ml: 1 }}>
                  {feature.title}
                </Typography>
              </Box>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mb: 2, flexGrow: 1 }}
              >
                {feature.description}
              </Typography>

              <Button
                variant="contained"
                color="primary"
                onClick={() => handleNavigate(feature.path)}
                sx={{ mt: "auto" }}
              >
                MANAGE
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* <Paper
        elevation={2}
        sx={{
          mt: 4,
          p: 3,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
        }}
      > */}
      <Divider sx={{ mt: 4, mb: 4, gap: 4 }} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h5" component="h2">
          Recent Activity
        </Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={fetchRecentActivity}
          disabled={loading}
        >
          Refresh
        </Button>
      </Box>

      {loading ? (
        <Typography>Loading recent activity...</Typography>
      ) : error ? (
        <Typography color="error">Error: {error}</Typography>
      ) : recentActivity.length === 0 ? (
        <Typography>No recent activity available</Typography>
      ) : (
        <List>
          {recentActivity.map((activity, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                {activity.type === "download" ? (
                  <DownloadIcon color="action" />
                ) : (
                  <UserIcon color="action" />
                )}
              </ListItemIcon>
              <ListItemText
                primary={activity.title}
                secondary={
                  <div>
                    <div>{activity.description}</div>
                    {activity.details && activity.details.length > 0 && (
                      <div
                        style={{
                          marginTop: 8,
                          fontSize: "0.85em",
                          color: "gray",
                        }}
                      >
                        {activity.type === "download" && (
                          <div>
                            Recent: {activity.details[0].product} v
                            {activity.details[0].version} by{" "}
                            {activity.details[0].user}
                          </div>
                        )}
                        {activity.type === "user" && activity.details[0] && (
                          <div>Latest: {activity.details[0].email}</div>
                        )}
                      </div>
                    )}
                  </div>
                }
              />
            </ListItem>
          ))}
        </List>
      )}
      {/* </Paper> */}
    </Container>
  );
};

export default AdminDashboardPage;
